import {
  WithStyles,
  Theme,
  createStyles,
  withStyles,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Divider,
  Switch,
  Typography,
} from "@material-ui/core";
import * as React from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import imagePlacholder from "../assets/images/image-placeholder.png";
import { isEmpty } from "../constants/constants";
import emptyTrash from "../assets/images/empty_trash.png";
import AddIcon from "@material-ui/icons/Add";
import { ConfigurationService } from "../services/ConfigurationService";
import AddConfigurationDialog from "./AddConfigurationDialog";
import { EventEmitter } from "../events/EventEmitter";
import { SNACKBAR_TYPE } from "../components/SnackBarComponent";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import GenericDialog from "./GenericDialog";
import { types } from "./AddCompanyDialog";
import { CompaniesService } from "../services/CompaniesService";
const CustomSwitch = withStyles({
  switchBase: {
    color: "orange",
    "&$checked": {
      color: "orange",
    },
    "&$checked + $track": {
      backgroundColor: "orange",
    },
  },
  checked: {},
  track: {
    backgroundColor: "grey",
  },
})(Switch);
const styles = (theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
      backgroundColor: theme.palette.background.paper,
    },
    img: {
      margin: 10,
      "max-width": 100,
      "max-height": 100,
      overflow: "hidden",
    },
    button: {
      margin: theme.spacing(1),
    },
    margin: {
      margin: theme.spacing(1),
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
    paper: {},
  });
interface Props extends WithStyles<typeof styles> {
  open: any;
  dialogTitle: any;
  onClose: any;
}
class ConfigurationsDialog extends React.Component<Props> {
  state = {
    allComapanies: [],
    companies: [],
    showAddCompanyConfigDialog: false,
    selectedCompany: { name: "", _id: "" },
    openConfirmationDialog: false,
  };

  componentDidMount = () => {
    this.getConfigurations();
    this.getCompanies();
  };

  componentDidUpdate = (prevProps: any, prevState: any) => {
    if (prevState.companies.length > this.state.companies.length) {
      this.getConfigurations();
      this.getCompanies();
    }
  };

  getCompanies = () => {
    let companiesService: CompaniesService = new CompaniesService();
    this.setState({
      isLoading: true,
    });
    companiesService.getCompanies().then((resp) => {
      this.setState({
        isLoading: false,
      });
      if (resp && resp.success && resp.companies) {
        this.setState({
          allComapanies: resp.companies,
        });
      } else {
        this.setState({
          showCompanies: false,
          showToolBarButton: false,
        });
        if (resp && resp.message) {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            show: true,
            type: SNACKBAR_TYPE.ERROR,
            message: resp.message,
          });
        }
      }
    });
  };

  getConfigurations = () => {
    this.setState({
      isLoading: true,
    });
    let configurationService: ConfigurationService = new ConfigurationService();
    configurationService.getConfigurations().then((resp) => {
      this.setState({
        isLoading: false,
      });
      if (resp && resp.success && resp.data) {
        this.setState({
          companies: resp.data.companies,
        });
      }
    });
  };
  handleConfirmedDelete = () => {
    this.setState({
      isLoading: true,
    });
    let configurationService: ConfigurationService = new ConfigurationService();
    configurationService
      .deleteConfiguration(this.state.selectedCompany._id)
      .then((resp) => {
        this.setState({
          isLoading: false,
          selectedCompany: {},
          openConfirmationDialog: false,
        });
        if (resp && resp.success && resp.updated) {
          this.getConfigurations();
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.SUCCESS,
            show: true,
            message: `Deleted Successfully`,
          });
        }
      });
  };
  handleOnDelete = (event: any, index: any) => {
    this.setState({
      openConfirmationDialog: true,
      selectedCompany: this.state.companies[index],
    });
  };
  handleOnEdit = (event: any, index: any) => {
    this.setState({
      showAddCompanyConfigDialog: true,
      selectedCompany: this.state.companies[index],
    });
  };
  handleOnSwitch = (event: any, index: any) => {
    let companies = this.state.companies;
    let company: any = companies[index];
    company.enabled = event.target.checked;

    this.setState(
      {
        companies: companies,
      },
      () => {
        this.setState({
          isLoading: true,
        });
        let configurationService: ConfigurationService =
          new ConfigurationService();
        configurationService
          .updateConfiguration(company._id, company.enabled)
          .then((resp) => {
            this.setState({
              isLoading: false,
            });
            if (resp && resp.success && resp.updated) {
              EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
                type: SNACKBAR_TYPE.SUCCESS,
                show: true,
                message: `${
                  company.enabled ? "Enabled" : "Disabled"
                } Successfully`,
              });
            }
          });
      }
    );
  };
  handleClose = () => {
    this.setState({
      showAddCompanyConfigDialog: false,
      selectedCompany: {},
      openConfirmationDialog: false,
    });
  };

  getCompany = (companyId: any) => {
    let companyies = this.state.allComapanies.filter((obj: any) => {
      return obj._id === companyId;
    });
    return companyies.length > 0 ? companyies[0] : null;
  };

  handleOnSubmit = (valuesObj: any) => {
    let company: any = this.getCompany(valuesObj.name);
    company = company ? company : this.getCompany(valuesObj.companyId);
    if (company) {
      let payload = {
        api: valuesObj.api,
        name: company.name,
        companyId: company._id,
        image: {
          base64: valuesObj.image.base64,
          filename: valuesObj.image.item.filename,
          imageId: valuesObj.image.item._id,
        },
        showAlert: valuesObj.showAlert,
        forcible: valuesObj.forcible,
        okButton: valuesObj.okButton,
        cancelButton: valuesObj.cancelButton,
        successAction: valuesObj.successAction,
        cancelAction: valuesObj.cancelAction,
        pageTitle: valuesObj.pageTitle,
        frequency: valuesObj.frequency,
        showOn: valuesObj.showOn,
        quickPicks: valuesObj.quickPicks,
        popupContent: valuesObj.popupContent,
      };
      let configurationService: ConfigurationService =
        new ConfigurationService();
      if (this.state.selectedCompany && this.state.selectedCompany.name) {
        this.setState({
          isLoading: true,
          selectedCompany: {},
          showAddCompanyConfigDialog: false,
        });
        configurationService
          .editConfiguration(payload, this.state.selectedCompany._id)
          .then((resp) => {
            this.setState({
              isLoading: false,
            });
            this.setState({ isLoading: false });
            if (resp && resp.success) {
              this.getConfigurations();
            }
          });
      } else {
        this.setState({
          isLoading: true,
          selectedCompany: {},
          showAddCompanyConfigDialog: false,
        });
        configurationService.addConfig(payload).then((resp) => {
          this.setState({
            isLoading: false,
          });
          this.setState({ isLoading: false });
          if (resp && resp.success) {
            this.getConfigurations();
          }
        });
      }
    }
  };
  renderAddConfigurationsDialog = () => {
    return (
      <AddConfigurationDialog
        open={this.state.showAddCompanyConfigDialog}
        dialogTitle={"Add Configurations"}
        handleClose={this.handleClose}
        editData={this.state.selectedCompany}
        allCompanies={this.state.allComapanies}
        handleOnSubmit={this.handleOnSubmit}
      />
    );
  };
  renderConfirmationDialog = () => {
    return (
      <GenericDialog
        type={types.DIALOG_INFO}
        title={`Deleting ${this.state.selectedCompany.name}`}
        message={"Are you sure want to delete this company"}
        leftButtonName={"Cancel"}
        rightButtonName={"YES"}
        open={this.state.openConfirmationDialog}
        onCancel={() => this.handleClose()}
        onOk={() => this.handleConfirmedDelete()}
        handleClose={() => this.handleClose()}
      />
    );
  };
  render() {
    const { open, classes, dialogTitle, onClose } = this.props;
    return (
      <React.Fragment>
        <Dialog
          open={open}
          keepMounted={true}
          maxWidth={"md"}
          onClose={() => onClose()}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
          fullWidth={true}
        >
          <DialogTitle id="confirmation-dialog-title">
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography variant="h6">{dialogTitle}</Typography>
              <Button
                variant="outlined"
                onClick={() => {
                  this.setState({
                    showAddCompanyConfigDialog: true,
                  });
                }}
                className={classes.button}
                startIcon={<AddIcon />}
              >
                Company
              </Button>
            </div>
          </DialogTitle>
          <DialogContent dividers>
            <div style={{ width: "100%" }}>
              {this.state.companies && this.state.companies.length > 0 ? (
                <List className={classes.root}>
                  {this.state.companies.map((company: any, index: any) => {
                    let base64 =
                      company.image && company.image.base64
                        ? Buffer.from(company.image.base64).toString("base64")
                        : "";
                    return (
                      <div key={index.toString()}>
                        <ListItem>
                          {!isEmpty(base64) ? (
                            <img
                              className={classes.img}
                              alt={`descr-${company.name}`}
                              src={`data:image/jpeg;base64,${base64}`}
                            />
                          ) : (
                            <img
                              className={classes.img}
                              alt="complex"
                              src={imagePlacholder}
                            />
                          )}
                          <ListItemText
                            style={{ marginLeft: 10 }}
                            primary={company.name}
                            secondary={`Connecting to: ${company.api}`}
                          />

                          <CustomSwitch
                            checked={company.enabled}
                            onChange={(event: any) =>
                              this.handleOnSwitch(event, index)
                            }
                            style={{
                              color: company.enabled ? "#f96500" : "white",
                            }}
                            name="checked"
                          />
                          <IconButton
                            aria-label="delete"
                            className={classes.margin}
                            onClick={(event: any) => {
                              this.handleOnDelete(event, index);
                            }}
                          >
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                          <IconButton
                            aria-label="edit"
                            className={classes.margin}
                            onClick={(event: any) => {
                              this.handleOnEdit(event, index);
                            }}
                          >
                            <EditIcon fontSize="small" />
                          </IconButton>
                        </ListItem>
                        <Divider variant={"inset"} />
                      </div>
                    );
                  })}
                </List>
              ) : (
                <div
                  style={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    overflow: "auto",
                  }}
                >
                  <img
                    src={emptyTrash}
                    style={{ width: 40, height: 40 }}
                    alt="Empty Trash"
                  />
                  <Typography
                    variant="h5"
                    gutterBottom
                    style={{ marginTop: 10, textAlign: "center" }}
                  >
                    {"No data available".toUpperCase()}
                  </Typography>
                </div>
              )}
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => onClose()}>Close</Button>
          </DialogActions>
        </Dialog>
        {this.renderAddConfigurationsDialog()}
        {this.renderConfirmationDialog()}
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(ConfigurationsDialog);
